/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import checkStyles from './CheckBox.module.less';

const Checkbox = React.forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = React.useRef();
  const resolvedRef = ref || defaultRef;

  React.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return (
    <div className={checkStyles.checkbox}>
      <label className={checkStyles.checkBoxContainer}>
        <input type="checkbox" ref={resolvedRef} {...rest} />
        <span className={checkStyles.checkMark} />
      </label>
    </div>
  );
});

Checkbox.propTypes = {
  indeterminate: PropTypes.bool,
};

export default Checkbox;
